module.exports = __webpack_public_path__ + "static/img/3.9f0abc1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/3.png
// module id = Coi4
// module chunks = 1